<template>
  <div class="toolbar">
    <i @click="flyToHome" class="el-icon-s-home" title="飞往预定位置"></i>
    <i @click="flyToVerticalView" class="el-icon-s-promotion" title="飞往预定视角"></i>
    <i
      @click="selfLocation"
      class="el-icon-aim"
      title="当前位置定位"
      :v-disabled="showlocationbutton"
    ></i>
    <i
      @click="switchMapmode"
      :class="mapmode === '三维' ? 'el-icon-turn-off' : 'el-icon-open'"
      :title="
        mapmode === '三维' ? '切换二三维地图:目前为三维' : '切换二三维地图:目前为二维'
      "
    ></i>
    <i style="font-size: 10px">{{ mapmode === "三维" ? "当前为三维" : "当前为二维" }}</i>
  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import Pop from "../../mapfunction/Pop.js";

export default {
  name: "full",
  data() {
    return {
      showlocationbutton: true,
      mapmode: "三维",
      src: require("../../../static/img/close.png"),
    };
  },
  methods: {
    flyToHome() {
      map3d.Camera.CameraAdjustment.flyTo(
        window.homeViewConfig.verticalView.position[0],
        window.homeViewConfig.verticalView.position[1],
        window.homeViewConfig.verticalView.height,
        window.homeViewConfig.verticalView.time
      );
    },
    flyToVerticalView() {
      map3d.Camera.CameraAdjustment.flyToFromData(
        window.homeViewConfig.birdView.camera,
        window.homeViewConfig.birdView.time
      );
    },
    switchMapmode() {
      if (this.mapmode === "三维") {
        this.ifHaveTerrainHandler();
        this.mapmode = "二维";
        window.globe.change2D();
        map3d_viewer.spd.setRequestRender();
        map3d_viewer.threecesium.stopRendering();
      } else if (this.mapmode === "二维") {
        this.ifHaveTerrainHandler();
        window.globe.change3D();
        map3d_viewer.viewer.scene.requestRenderMode = false;
        map3d_viewer.threecesium.reStartRendering();
        this.mapmode = "三维";
      }
      map3d_viewer.viewer.mouseHandlerManager.trigger("mapmodeChange", this.mapmode);
    },
    //判断是否有地形加载并进行处理
    ifHaveTerrainHandler() {
      if (window.lastcheckedterrain) {
        map3d_viewer.viewer.mouseHandlerManager.trigger(
          "addLayer",
          window.lastcheckedterrain
        );
        window.lastcheckedterrain = null;
      } else {
        window.layerManagerConfig[0].children.forEach((item2) => {
          if (item2.label === "地形数据") {
            let checkeditem;
            item2.children.forEach((item) => {
              if (item.checked) {
                checkeditem = item;
              }
            });
            window.lastcheckedterrain = checkeditem;
            map3d_viewer.viewer.scene.terrainProvider = new Cesium.EllipsoidTerrainProvider(
              {}
            );
          }
        });
      }
    },
    locationPlanA() {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            if (
              position &&
              position.coords &&
              position.coords.longitude &&
              position.coords.latitude &&
              typeof position.coords.longitude === "number" &&
              typeof position.coords.latitude === "number"
            ) {
              const lng = position.coords.longitude;
              const lat = position.coords.latitude;
              resolve({ lng: lng, lat: lat, type: "navigator" });
            }
          },
          () => {},
          { enableHighAcuracy: true }
        );
      });
    },
    locationPlanB() {
      return new Promise((resolve, reject) => {
        this.amapGeolocation.getCurrentPosition((status, result) => {
          if (
            result &&
            result.position &&
            result.position.lng &&
            result.position.lat &&
            typeof result.position.lng === "number" &&
            typeof result.position.lat === "number"
          ) {
            const lng = result.position.lng;
            const lat = result.position.lat;
            resolve({ lng: lng, lat: lat, type: "amap" });
          }
        });
      });
    },
    selfLocation() {
      if (!this.showlocationbutton) {
        this.$message({
          message: "请勿频繁请求",
          type: "warning",
        });
        return;
      } else {
        Pop.remove("定位点");
      }
      this.$message({
        message: "正在尝试请求实时位置",
        type: "success",
      });
      this.showlocationbutton = false;
      const p1 = this.locationPlanA();
      // const p2 = this.locationPlanB();
      const p3 = new Promise((resolve) => {
        setTimeout(() => {
          resolve("timeout");
        }, 10000);
      });
      Promise.race([p1, p3]).then((result) => {
        console.log(result);
        //添加点
        if (result && result.lng && result.lat) {
          Pop.addPop([result.lng, result.lat, 500], {
            url: "./static/img/billboard.png",
            id: "定位点",
          });
          map3d.Camera.CameraAdjustment.flyTo(result.lng, result.lat, 3000, 3, () => {
            this.showlocationbutton = true;
          });
          this.$message({
            message: "请求实时位置成功",
            type: "success",
          });
        } else {
          this.$message("请实时位置失败,请重新尝试");
          this.showlocationbutton = true;
        }
      });
      // .catch((err) => {
      //   this.$message("请实时位置失败,请重新尝试");
      //   this.showlocationbutton = true;
      // });

      // navigator.geolocation.getCurrentPosition(
      //   (position) => {
      //     const lng = position.coords.longitude;
      //     const lat = position.coords.latitude;

      //     //添加点
      //     Pop.addPop([lng, lat, 500], {
      //       url: "./static/img/billboard.png",
      //       id: "定位点",
      //     });
      //     if (typeof lng === "number" && typeof lat === "number") {
      //       map3d.Camera.CameraAdjustment.flyTo(lng, lat, 3000, 3, () => {
      //         this.showlocationbutton = true;
      //       });
      //       this.$message({
      //         message: "请求实时位置成功",
      //         type: "success",
      //       });
      //     }
      //   },
      //   () => {
      //     this.$message("请实时位置失败,请重新尝试");
      //     this.showlocationbutton = true;
      //   }
      // );

      // this.amapGeolocation.getCurrentPosition((status, result) => {
      //   const lng = result.position.lng;
      //   const lat = result.position.lat;
      //   //添加点
      //   Pop.addPop([lng, lat, 500], {
      //     url: "./static/img/billboard.png",
      //     id: "定位点",
      //   });
      //   if (typeof lng === "number" && typeof lat === "number") {
      //     map3d.Camera.CameraAdjustment.flyTo(lng, lat, 3000, 3, () => {
      //       this.showlocationbutton = true;
      //     });
      //     this.$message({
      //       message: "请求实时位置成功",
      //       type: "success",
      //     });
      //   }
      // });
    },
  },
  mounted() {
    // if (window.amapKey) {
    //   AMapLoader.load({
    //     key: window.amapKey,
    //     version: "2.0",
    //     plugins: ["AMap.Geolocation"],
    //   })
    //     .then((AMap) => {
    //       this.AMap = AMap;
    //       this.amapGeolocation = new AMap.Geolocation({
    //         // 是否使用高精度定位，默认：true
    //         enableHighAccuracy: false,
    //         convert: false,
    //         // 设置定位超时时间，默认：无穷大
    //         timeout: 20000,
    //       });
    //     })
    //     .catch((e) => {
    //       console.error("注册高德地图服务失败:" + e);
    //     });
    // } else {
    //   this.$message({
    //     message: "没有填写高德地图开发者key",
    //     type: "error",
    //   });
    // }
  },
};
</script>

<style scoped>
.home {
  position: absolute;
  background: #01478d;
  height: 100%;
  width: 100%;
}
.toolbar {
  color: white;
  position: absolute;
  left: 97%;
  cursor: pointer;
  top: 72%;
  height: 40px;
  width: 40px;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  background: transparent;
  font-size: 40px;
}
.toolbar i {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/flyhome.vue